// extracted by mini-css-extract-plugin
export default {"text-input":"vrieDG1","text-input__element":"igJ0wlF","text-input__label":"J_zihef","text-input__icon":"PL4nCjm","text-input__input-message":"yE4Rsg6","text-input--error":"d3zpKu6"};